import React from 'react';
import {SurveyPagePropTypes, PageNavigation} from '@ignitesales/neuro-application';
import PerfectScrollbar from "react-perfect-scrollbar";
import {scrollToTop} from "../../../../../../../shared/js";

const SurveyPage = ({ className, componentClass, renderQuestionGroups }) => {
  return (
    <div className={className}>
        <div className={`${componentClass}__container container`}>
            <div className={`${componentClass}__question-box`} />
            <div className={`${componentClass}__questions`}>
                <div className={`questionGroups ${componentClass}__questionGroups`}>
                    <PerfectScrollbar>{ renderQuestionGroups() }</PerfectScrollbar>
                </div>
                <div className={`${componentClass}__divider`} />
            </div>
            <PageNavigation className={`${componentClass}__navigation`} onNextPageClicked={ scrollToTop } onPreviousPageClicked={ scrollToTop } />
        </div>

    </div>
  );
};

SurveyPage.propTypes = SurveyPagePropTypes;

export default SurveyPage;
